<template>
  <div class="container">
    <Explainer :show="showHelper" />
    <div class="logo--wrapper">
      <svg class="logo" xmlns="http://www.w3.org/2000/svg" width="109.656" height="35.856" viewBox="0 0 109.656 35.856"><path class="a" d="M-.072-25.488h6.12L10.116-9.144h.072l5.328-16.344h5.22L26.028-8.712H26.1l4.284-16.776h5.688L28.62,0h-5L18-17.64h-.072L12.312,0H7.488Zm35.6,16.74a9.166,9.166,0,0,1,.756-3.78,8.7,8.7,0,0,1,2.07-2.9,9.142,9.142,0,0,1,3.1-1.854,11.027,11.027,0,0,1,3.8-.648,11.027,11.027,0,0,1,3.8.648,9.141,9.141,0,0,1,3.1,1.854,8.7,8.7,0,0,1,2.07,2.9,9.166,9.166,0,0,1,.756,3.78,9.166,9.166,0,0,1-.756,3.78,8.7,8.7,0,0,1-2.07,2.9,9.141,9.141,0,0,1-3.1,1.854,11.027,11.027,0,0,1-3.8.648,11.027,11.027,0,0,1-3.8-.648,9.142,9.142,0,0,1-3.1-1.854,8.7,8.7,0,0,1-2.07-2.9A9.166,9.166,0,0,1,35.532-8.748Zm5.4,0a4.527,4.527,0,0,0,1.134,3.2A4.128,4.128,0,0,0,45.252-4.32a4.128,4.128,0,0,0,3.186-1.224,4.527,4.527,0,0,0,1.134-3.2,4.527,4.527,0,0,0-1.134-3.2,4.128,4.128,0,0,0-3.186-1.224,4.128,4.128,0,0,0-3.186,1.224A4.527,4.527,0,0,0,40.932-8.748ZM57.06-17.5h5.4v2.808h.072a6.637,6.637,0,0,1,2.052-2.43,5.187,5.187,0,0,1,2.988-.81q.468,0,.936.036a4.635,4.635,0,0,1,.864.144v4.932a8.157,8.157,0,0,0-1.134-.27,7.343,7.343,0,0,0-1.17-.09,5.738,5.738,0,0,0-2.448.432,3.25,3.25,0,0,0-1.386,1.206,4.583,4.583,0,0,0-.63,1.854,18.053,18.053,0,0,0-.144,2.376V0h-5.4ZM88.344,0H83.376V-2.3H83.3a5.967,5.967,0,0,1-.846.954,6.4,6.4,0,0,1-1.224.882A7.492,7.492,0,0,1,79.686.18,6.083,6.083,0,0,1,77.94.432a9.018,9.018,0,0,1-3.528-.666,7.867,7.867,0,0,1-2.718-1.872,8.347,8.347,0,0,1-1.746-2.862A10.415,10.415,0,0,1,69.336-8.6a11.026,11.026,0,0,1,.558-3.51,9.66,9.66,0,0,1,1.584-2.97,7.738,7.738,0,0,1,2.5-2.07,7.1,7.1,0,0,1,3.348-.774,9.278,9.278,0,0,1,3.15.522,5.041,5.041,0,0,1,2.394,1.782h.072V-27.216h5.4ZM83.376-8.748a4.527,4.527,0,0,0-1.134-3.2,4.128,4.128,0,0,0-3.186-1.224,4.128,4.128,0,0,0-3.186,1.224,4.527,4.527,0,0,0-1.134,3.2,4.527,4.527,0,0,0,1.134,3.2A4.128,4.128,0,0,0,79.056-4.32a4.128,4.128,0,0,0,3.186-1.224A4.527,4.527,0,0,0,83.376-8.748ZM101.664,2.844q-.54,1.4-1.044,2.484a5.961,5.961,0,0,1-1.278,1.818A4.978,4.978,0,0,1,97.38,8.262a10.608,10.608,0,0,1-3.132.378,12.666,12.666,0,0,1-4.032-.648l.72-4.428a6.182,6.182,0,0,0,2.52.54,4.619,4.619,0,0,0,1.476-.2,2.451,2.451,0,0,0,.954-.576,3.192,3.192,0,0,0,.63-.918q.252-.54.54-1.26l.4-1.008L89.784-17.5h5.832l4.5,11.556h.072L104.04-17.5h5.544Z" transform="translate(0.072 27.216)"/></svg>
    </div>
    <Wordie @getNewWord="newWord" />
  </div>
</template>

<script>
import Wordie from './components/Wordie.vue'
import Explainer from './components/Explainer.vue'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    Wordie,
    Explainer
  },
  data(){
    return{
      baseUrl: process.env.VUE_APP_BASE_URL,
      allWords:null,
      theWord: null,
      changeWord:false,
      showHelper:false
    }
  },
  created(){
    // Fetch Data
    this.fetchData();
    let hasPlayed = localStorage.getItem('wordify_success');
    if(hasPlayed == null){
      localStorage.setItem('wordify_success',0)
    }
    let playData = localStorage.getItem('wordify_play_data');
    if(playData == null){
      localStorage.setItem('wordify_play_data',JSON.stringify([{"first_timer":true,"best_streak":0}]))
    }

    let helper = localStorage.getItem('wordify_helper');
    if(helper == null){
      this.showHelper = true;
    }
  },
  mounted(){
    //console.log(this.$refs.wordrow)
  },
  methods:{
    fetchData(){
      axios.get(this.baseUrl + 'swewords.json').then(response => {
          this.allWords = response.data;
          
          this.getWord()
      })
    },
    getWord(){
      // No cheat!
      let currentlyPlaying = localStorage.getItem('wordify_playing');
      if(currentlyPlaying == null){
        let selWord = this.allWords[Math.floor(Math.random() * this.allWords.length)];
        this.theWord = btoa(selWord)
        
        localStorage.setItem('wordify_playing',JSON.stringify({"rows":["","","","","",""],"ev":[[],[],[],[],[],[]],activeRow:0,wrd:this.theWord}))
      } else {
        this.theWord = JSON.parse(localStorage.getItem('wordify_playing')).wrd;
      }
    },
    newWord(){
      let selWord = this.allWords[Math.floor(Math.random() * this.allWords.length)];
      this.theWord = btoa(selWord)
      localStorage.setItem('wordify_playing',JSON.stringify({"rows":["","","","","",""],"ev":[[],[],[],[],[],[]],activeRow:0,wrd:this.theWord}))
    },
    enc(word){
      if(word && word.length > 0){
        let encWord = atob(word);
        return encWord;
      }
      return;
    }
  }
}
</script>

<style>
.theword{
  position:absolute;
  top:0;
  left:0;
  padding:8px;
  background:black;
}

:root {
  --main-bg-color: #08121b;
  --keyboard-btn:#b5bec7;
  --keyboard-btn-color: #08121b;
  --keyboard-btn-color-correct:#00da91;
  --keyboard-btn-color-present:#dacb00;
  --keyboard-btn-color-absent:#394653;
  --keyboard-btn-color-na:#dacb0016;
  --error:#ee0028;
}
*{
  box-sizing: border-box;
}
body{
  background:var(--main-bg-color);
  margin:0;
  font-size:16px;
  height:100vh;
  overflow:hidden;
}
.logo{
  height: 4vh;
  width: 17vh;
}
.logo--wrapper {
    padding: 2vh 0 0;
}
.logo .a{
  fill:#e5ebff;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
.relative{
  position:relative;
}
.container{
  width:100%;
  padding:0 20px;
  margin:0 auto;
}
@media(min-width:767px){
  .container{
    max-width:640px;
  }
}

.capitalize{
    text-transform: capitalize;
}
.flex{
  display:flex;
} 
.flex-row{
  flex-direction:row;
}
.grid-row{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 5px;
}
.board-grid{
  display: grid;
  grid-template-rows: repeat(6, 1fr);
  grid-gap: 5px;
  padding: 10px;
  box-sizing: border-box;
  height: 55vh;
  width: 55vh;
  margin: .5vh auto;
}
.justify-center{
  justify-content:center;
}

*[evaluation*="correct"],
.letter[evaluation*="correct"] {
    background-color: var(--keyboard-btn-color-correct);
    color: var(--keyboard-btn-color);
}
*:not(.letter)[evaluation="absent"] {
    background-color: var(--keyboard-btn-color-absent);
    color: var(--keyboard-btn-color);
}
*[evaluation*="present"],
.letter[evaluation*="present"]{
    background-color: var(--keyboard-btn-color-present);
    color: var(--keyboard-btn-color);
}
.letter[evaluation*="n/a"]{
    background-color: var(--keyboard-btn-color-na);
}

/* Do not show second if multiple present twice is visible */
.letter[evaluation*="present twice"]:nth-of-type(2n+1),
.letter[evaluation*="present twice but-before"] {
    background: transparent;
    color: white;
}

.letter{
  position:relative;
}
.letter[evaluation*="double"]::after{
  content:'x2';
  position:absolute;
  top:0;
  right:0;
  width:16px;
  height:16px;
  font-size:8px;
  text-transform: none;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-top:-6px;
  margin-right:-6px;
  background-color: white;
  border-radius:100%;
}

.font-bold{
  font-weight:900;
}
.text-white{
  color:white;
}
.text-green{
  color:var(--keyboard-btn-color-correct);
}

@media(max-width:767px){
  .board-grid{
    width:100%;
    padding: 0;
    height: 45vh;
    margin-top: 110px;
  }
  .container {
    padding: 0 10px;
  }
  .logo--wrapper {
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 24px;
    padding: 0;
  }
}
@media(max-width:340px){
  .board-grid{
    height: 40vh;
  }
}
</style>
